//import angular from 'angular';


    angular.module('app')
        .factory('stocktakeFactory', [
            'amtXlatSvc', 'amtCommandQuerySvc', 'enums', 'confirmSvc', 'exportSvc',
            function (amtXlatSvc, amtCommandQuerySvc, enums, confirmSvc, exportSvc) {

                // static functions
                this.export = function (criteria) {
                    exportSvc.exportData('stocktake/exportStocktakes', criteria, amtXlatSvc.xlat('stocktake.searchExportFilename'));
                };
                
                this.startOfMonth = function () {
                    var now = new Date();

                    // return the first of the current month
                    return new Date(now.getFullYear(), now.getMonth(), 1);
                };

                // static data
                var searchCriteria = {
                    filterValues: {
                        dateFrom: this.startOfMonth(),
                        dateTo: new Date()                        
                    },
                    forExport: false,
                    group: [],
                    page: 1,
                    pageSize: 10,
                    skip: 0,
                    take: 10
                };

                // public interface
                return {
                    export: this.export,
                    searchCriteria: searchCriteria
                };
            }
        ]
    );
